// BE `UrlRules.BeSafeUrl` aynası (SEC M-1): boş serbest, "/" ile başlayan site-içi yol
// ("//host" open-redirect hariç) veya mutlak http(s). javascript:/data: gibi inline
// scheme'ler reddedilir — public site bu değerleri <a href> olarak render eder.
export function isSafeUrl(value: string | null | undefined): boolean {
  if (!value || !value.trim()) return true;
  const v = value.trim();
  if (v.startsWith('/')) return !v.startsWith('//');
  if (!/^https?:\/\//i.test(v)) return false;
  try {
    const parsed = new URL(v);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

// AntD Form.Item rules dizisine eklenecek validator.
export function safeUrlRule(message: string) {
  return {
    validator: (_rule: unknown, value: unknown) =>
      isSafeUrl(typeof value === 'string' ? value : undefined)
        ? Promise.resolve()
        : Promise.reject(new Error(message)),
  };
}
